/* Free delivery nudges (29 Oct 2026). Plain JS, no framework. Three parts, each switched by its own theme setting
   (the Liquid renders nothing when a part is off, so this file then finds nothing to do):
   1. Basket (snippets/fd-nudge-cart.liquid, drawer and basket page; the gap and milestone bar at the top, the
      "People bought these products with..." list at the bottom): Add puts the add-on in the basket nested
      under its hamper, one per hamper on that line, as the drawer's add-on carousel does, then on:cart:change
      refreshes the drawer, the basket page, the header and the totals.
   2. Send to different addresses (snippets/fd-nudge-split-data.liquid + the fdnSplit hook in
      assets/split-recipients.js): one line per recipient under the threshold, one add-on that would get that
      parcel there; Add puts it in the basket under that person's first hamper and on that hamper's addons, so it
      rides in the /checkout payload for that person.
   3. Product page (snippets/fd-nudge-pdp.liquid): keeps the line right when the variant or quantity changes.
   Every add also pushes a dataLayer event fd_nudge_add (where, product), for measuring. */
(function () {
  'use strict';
  if (window.ImpFdNudge && window.ImpFdNudge.loaded) return;

  function dl(evt, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      var o = { event: evt };
      for (var k in data) if (Object.prototype.hasOwnProperty.call(data, k)) o[k] = data[k];
      window.dataLayer.push(o);
    } catch (e) { /* ignore */ }
  }

  function money(pence) {
    var fmt = (window.theme && theme.moneyFormat) || '\u00a3{{amount}}';
    var amount = (Math.round(pence) / 100).toFixed(2);
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(pence / 100)))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas)
      .replace(/<[^>]*>/g, '');
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function addToCart(variantId, qty, parentId, parentTitle) {
    var item = { id: Number(variantId), quantity: qty || 1 };
    if (parentId) item.properties = { _parent_box_id: parentId, _parent_box_title: parentTitle || '' };
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [item] })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error((data && (data.description || data.message)) || 'Could not add');
        return data;
      });
    });
  }

  /* ---------------------------------------------------------------- 1. basket */
  var seen = {};
  function noteShown() {
    document.querySelectorAll('[data-fdn-cart]').forEach(function (el) {
      var where = el.getAttribute('data-fdn-where') || '';
      if (seen[where] || !el.offsetParent) return;
      seen[where] = true;
      dl('fd_nudge_view', { fdn_where: where, fdn_gap_pence: parseInt(el.getAttribute('data-fdn-gap'), 10) || 0 });
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-fdn-add]');
    if (!btn) return;
    var li = btn.closest('[data-fdn-item]');
    if (!li || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    var sel = li.querySelector('.fdn__variant');
    var variant = (sel && sel.value) || li.getAttribute('data-variant');
    var qty = parseInt(li.getAttribute('data-qty'), 10) || 1;
    var box = li.closest('[data-fdn-cart]');
    btn.disabled = true;
    btn.textContent = 'Adding';
    addToCart(variant, qty, li.getAttribute('data-parent'), li.getAttribute('data-parent-title'))
      .then(function () {
        dl('fd_nudge_add', { fdn_where: box ? box.getAttribute('data-fdn-where') : '', fdn_name: li.getAttribute('data-name') || '' });
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = 'Add';
        var msg = li.querySelector('.fdn__err');
        if (!msg) {
          msg = document.createElement('span');
          msg.className = 'fdn__err';
          li.querySelector('.fdn__text').appendChild(msg);
        }
        msg.textContent = (err && err.message) || 'Could not add this just now';
      });
  });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('fdn__variant')) e.stopPropagation();
  }, true);
  document.addEventListener('on:cart:after-merge', function () { setTimeout(noteShown, 50); });
  document.addEventListener('theme:open-cart-drawer', function () { setTimeout(noteShown, 400); });

  /* ---------------------------------------------------------------- 3. product page */
  /* Liv's review 29 Oct: the Liquid only lists add-ons of GBP 15 or more (settings.fdn_min_addon) with their category
     rank (0 wicker, 1 chocolates, 2 cards, 3 the rest). One that reaches the threshold: lowest rank, then cheapest.
     Else the cheapest pair, never two wicker baskets. */
  function rankOf(a) { return a.rank == null ? 3 : a.rank; }
  function pdpPick(data, gap) {
    var list = (data.addons || []).slice().sort(function (a, b) { return a.price - b.price; });
    var ones = list.filter(function (a) { return a.price >= gap; })
      .sort(function (a, b) { return (rankOf(a) - rankOf(b)) || (a.price - b.price); });
    if (ones.length) return [ones[0]];
    var best = null;
    var bestSum = Infinity;
    for (var a = 0; a < list.length; a++) {
      for (var b = a + 1; b < list.length; b++) {
        if (rankOf(list[a]) === 0 && rankOf(list[b]) === 0) continue;
        var s = list[a].price + list[b].price;
        if (s >= gap && s < bestSum) { best = [list[a], list[b]]; bestSum = s; }
      }
    }
    return best;
  }

  function pdpUpdate(box, variantId) {
    var dataEl = box.querySelector('[data-fdn-pdp-data]');
    var line = box.querySelector('[data-fdn-pdp-line]');
    if (!dataEl || !line) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var form = box.closest('.js-product') || document;
    if (!variantId) {
      var idInput = form.querySelector('form[action*="/cart/add"] [name="id"]');
      variantId = idInput && idInput.value;
    }
    var v = data.variants[String(variantId)];
    var qtyInput = form.querySelector('form[action*="/cart/add"] [name="quantity"], input[name="quantity"]');
    var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    var pick = null;
    if (v && v.ships) {
      var gap = data.threshold - v.price * qty;
      if (gap > 0) pick = pdpPick(data, gap);
    }
    if (!pick) { line.hidden = true; return; }
    var html = 'Add ' + pick.map(function (p) {
      return '<button type="button" class="fdn-pdp__name" data-fdn-pid="' + p.id + '">' + esc(p.name) + '</button>';
    }).join(' and ') + ' for free delivery';
    if (line.innerHTML.replace(/\s+/g, ' ').trim() !== html) line.innerHTML = html;
    line.hidden = false;
  }

  function pdpInit() {
    document.querySelectorAll('[data-fdn-pdp]').forEach(function (box) {
      if (box._fdn) return;
      box._fdn = true;
      var scope = box.closest('.js-product') || document;
      scope.addEventListener('on:variant:change', function (e) {
        var v = e.detail && e.detail.variant;
        pdpUpdate(box, v && v.id);
      });
      scope.addEventListener('change', function (e) {
        if (e.target && e.target.name === 'quantity') pdpUpdate(box);
      });
      scope.addEventListener('input', function (e) {
        if (e.target && e.target.name === 'quantity') pdpUpdate(box);
      });
      scope.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.quantity-up, .quantity-down, [data-qty-btn], .qty-btn')) setTimeout(function () { pdpUpdate(box); }, 30);
      });
      if (!box.querySelector('[data-fdn-pdp-line]').hidden) dl('fd_nudge_view', { fdn_where: 'product' });
    });
  }

  /* A name in the line points at its card in the Upgrade your gift row, when the row has it. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.fdn-pdp__name');
    if (!b) return;
    e.preventDefault();
    var card = document.querySelector('.mm-hamper-upgrade__item[data-hu-product-id="' + b.getAttribute('data-fdn-pid') + '"]');
    var row = document.querySelector('.mm-hamper-upgrade');
    var target = card || row;
    if (!target) return;
    var more = row && row.querySelector('[data-hu-more][aria-expanded="false"]');
    if (card && more && card.offsetParent === null) more.click();
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (card) {
      card.classList.add('fdn-pulse');
      setTimeout(function () { card.classList.remove('fdn-pulse'); }, 1800);
    }
    dl('fd_nudge_point', { fdn_where: 'product' });
  });

  /* ---------------------------------------------------------------- 2. send to different addresses */
  var REMOTE = { highlands: 1, islands: 1, ni: 1, wight: 1, channel: 1, man: 1, scilly: 1 };
  var splitData = null;
  function splitCfg() {
    if (splitData !== null) return splitData;
    var el = document.querySelector('[data-fdn-split]');
    try { splitData = el ? JSON.parse(el.textContent) : false; } catch (e) { splitData = false; }
    return splitData;
  }
  var splitChoice = {};

  function splitPick(r, api, gap) {
    var data = splitCfg();
    if (!data) return null;
    var have = {};
    var firstUnit = null;
    r.units.forEach(function (uid) {
      var u = api.findUnit(uid);
      if (!u) return;
      if (!firstUnit && u.item_id) firstUnit = u;
      have['p' + u.product_id] = true;
      u.addons.forEach(function (a) { have['v' + a.variant_id] = true; have['h' + a.handle] = true; });
    });
    if (!firstUnit) return null;
    var cands = [];
    var seenP = {};
    r.units.forEach(function (uid) {
      var u = api.findUnit(uid);
      if (!u) return;
      (data.byProduct[String(u.product_id)] || []).forEach(function (a) {
        if (seenP[a.product_id] || have['p' + a.product_id] || !a.variants || !a.variants.length) return;
        var already = a.variants.some(function (v) { return have['v' + v.id]; });
        if (already) return;
        seenP[a.product_id] = true;
        cands.push(a);
      });
    });
    /* Liv's review 29 Oct: only add-ons of GBP 15 or more (minPence; the Liquid already leaves the rest out), and
       inside "reaches the threshold" (cheapest) or else "nearest", her category order first: wicker, chocolates,
       cards, the rest */
    var floor = data.minPence || 1500;
    cands = cands.filter(function (a) { return a.variants[0].price >= floor; });
    if (!cands.length) return null;
    var price = function (a) { return a.variants[0].price; };
    var closes = cands.filter(function (a) { return price(a) >= gap; })
      .sort(function (a, b) { return (rankOf(a) - rankOf(b)) || (price(a) - price(b)); });
    var pick = closes[0] || cands.sort(function (a, b) { return (rankOf(a) - rankOf(b)) || ((gap - price(a)) - (gap - price(b))); })[0];
    return { addon: pick, unit: firstUnit, closes: !!closes[0] };
  }

  function splitHtml(r, api) {
    var data = splitCfg();
    if (!data || !r || !r.units || !r.units.length) return '';
    if (api.cfg.freeRule === 'order_total') return '';
    if (r.region && REMOTE[r.region]) return '';
    var value = api.parcelValuePence(r);
    var gap = (api.cfg.freeThresholdPence || 10000) - value;
    if (gap <= 0) return '';
    var p = splitPick(r, api, gap);
    if (!p) return '';
    var a = p.addon;
    var who = String(r.name || '').trim();
    var chosen = splitChoice[r.id + ':' + a.product_id];
    var html = '<div class="fdn fdn--split" data-fdn-split-for="' + esc(r.id) + '">';
    html += '<p class="fdn__gap"><strong>' + esc(api.money ? api.money(gap) : money(gap)) + '</strong> to free delivery for <span class="fdn__who" data-fdn-who="' + esc(r.id) + '">' + (who ? esc(who) : 'this parcel') + '</span></p>';
    html += '<div class="fdn__item fdn__item--split">';
    html += '<span class="fdn__img">' + (a.image ? '<img src="' + esc(a.image) + '" alt="" width="48" height="48" loading="lazy">' : '') + '</span>';
    html += '<span class="fdn__text"><span class="fdn__name">' + esc(a.name) + '</span><span class="fdn__price">' + esc(api.money ? api.money(a.variants[0].price) : money(a.variants[0].price)) + '</span>';
    if (a.variants.length > 1) {
      html += '<select class="fdn__variant" data-fdn-split-variant="' + esc(r.id) + ':' + a.product_id + '" aria-label="Choose an option for ' + esc(a.name) + '">';
      a.variants.forEach(function (v) {
        var sel = chosen ? String(chosen) === String(v.id) : (data.christmasFirst && v.title === 'Merry Christmas');
        html += '<option value="' + v.id + '"' + (sel ? ' selected' : '') + '>' + esc(v.title) + '</option>';
      });
      html += '</select>';
    }
    html += '</span>';
    html += '<button type="button" class="fdn__add" data-fdn-split-add="' + esc(r.id) + '" data-product="' + a.product_id + '" aria-label="Add ' + esc(a.name) + (who ? ' for ' + esc(who) : '') + '">Add</button>';
    html += '</div></div>';
    if (!r._fdnSeen) { r._fdnSeen = true; dl('fd_nudge_view', { fdn_where: 'split', fdn_gap_pence: gap }); }
    return html;
  }

  /* the name typed on the card shows in its line straight away */
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-field="name"][data-recipient]')) return;
    var w = document.querySelector('[data-fdn-who="' + t.getAttribute('data-recipient') + '"]');
    if (w) w.textContent = String(t.value || '').trim() || 'this parcel';
  });

  document.addEventListener('change', function (e) {
    var s = e.target && e.target.getAttribute && e.target.getAttribute('data-fdn-split-variant');
    if (s) splitChoice[s] = e.target.value;
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-fdn-split-add]');
    if (!btn || btn.disabled) return;
    var api = window.ImpSplitFdn;
    if (!api) return;
    e.preventDefault();
    e.stopPropagation();
    var r = null;
    api.state.recipients.forEach(function (x) { if (x.id === btn.getAttribute('data-fdn-split-add')) r = x; });
    if (!r) return;
    var gap = (api.cfg.freeThresholdPence || 10000) - api.parcelValuePence(r);
    var p = splitPick(r, api, gap);
    if (!p || String(p.addon.product_id) !== btn.getAttribute('data-product')) return;
    var box = btn.closest('.fdn__item');
    var sel = box && box.querySelector('.fdn__variant');
    var vid = (sel && sel.value) || p.addon.variants[0].id;
    var variant = p.addon.variants.filter(function (v) { return String(v.id) === String(vid); })[0] || p.addon.variants[0];
    var u = p.unit;
    btn.disabled = true;
    btn.textContent = 'Adding';
    addToCart(variant.id, 1, u.item_id, u.title)
      .then(function (data) {
        var line = (data.items && data.items[0]) || data;
        var existing = null;
        u.addons.forEach(function (x) { if (x.line_key === line.key) existing = x; });
        var unitPrice = line.final_price != null ? line.final_price : (line.price != null ? line.price : variant.price);
        if (existing) {
          existing.quantity += 1;
        } else {
          u.addons.push({
            line_key: line.key,
            variant_id: line.variant_id || variant.id,
            handle: line.handle || '',
            title: line.product_title || p.addon.name,
            variant_title: line.variant_title || (p.addon.variants.length > 1 ? variant.title : ''),
            quantity: 1,
            price: unitPrice
          });
        }
        api.state.orderTotalPence = (api.state.orderTotalPence || 0) + unitPrice;
        dl('fd_nudge_add', { fdn_where: 'split', fdn_name: p.addon.name });
        api.save();
        api.render();
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = 'Add';
        var t = box && box.querySelector('.fdn__text');
        if (t && !t.querySelector('.fdn__err')) {
          var m = document.createElement('span');
          m.className = 'fdn__err';
          m.textContent = (err && err.message) || 'Could not add this just now';
          t.appendChild(m);
        }
      });
  });

  window.ImpFdNudge = { loaded: true, splitHtml: splitHtml };

  function boot() {
    pdpInit();
    noteShown();
    /* the split page may have painted before this file loaded */
    if (window.ImpSplitFdn && splitCfg() && window.ImpSplitFdn.state.units && window.ImpSplitFdn.state.units.length) {
      try { window.ImpSplitFdn.render(); } catch (e) { /* ignore */ }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
